import React, { useState } from 'react'
import { MockProducts } from '@mockdata/mockdata'
import { Transition } from '@headlessui/react'

const IndicatorItem = ({data, size='size-2', placeTop = false, placeLeft = false, ...props}) => {
  const [isActive, setIsActive] = useState(false)
  
  return (
    <React.Fragment>
      <div className={`relative w-fit`} style={props.style} onMouseEnter={() => setIsActive(true)} onMouseLeave={() => setIsActive(false)}>
        <div className='cursor-pointer border rounded-full z-20'>
          <div className={`rounded-full ${size} bg-gray-300 m-1`} />
        </div>
        <Transition
          show={isActive}
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leaveTo='opacity-0'
        >
          <div className={`absolute duration-300 ${placeLeft ? 'right-2.5' : 'left-2.5'} ${placeTop ? 'bottom-2.5' : 'top-2.5'} bg-white z-20 min-w-[180px] min-h-[60px] p-2 flex flex-nowrap gap-2 items-center ${isActive ? 'block' : 'hidden'}`}>
            <img src={data?.imageUrl} alt={'indicator-thumb'} className='w-9 h-auto object-cover p-1' loading='lazy' />
            <div className='flex flex-col justify-between'>
              <div className='text-sm font-medium'>{data?.title?.split(" / ")?.[0]}</div>
              <div className='text-xs text-secondary'>{data?.title?.split(" / ")?.[1]}</div>
            </div>
          </div>
        </Transition>
      </div>
    </React.Fragment>
  )
}

export default IndicatorItem